import { Helmet } from 'react-helmet-async';

type SeoProps = {
  title: string;
  description?: string;
  image?: string;
  url: string;
  name?: string;
  logo?: string;
  keywords: string[];
  uploadDate: string;
  includeVideoSchema: boolean;
  thumbnailUrl1?: string;
  thumbnailUrl2?: string;
  contentUrl1?: string;
  contentUrl2?: string;
  videotitle1?: string;
  videotitle2?: string;
  videodescription1?: string;
  videodescription2?: string;
};

const Seo = ({
  title,
  description = 'Try Rouse – a science-backed rehydration + intimacy drink.',
  logo = 'https://therouseco.com/assets/rouse_logo_3d-0556870b.webp',
  image = 'https://therouseco.com/assets/rouse_logo_3d-0556870b.webp',
  url = 'https://therouseco.com',
  name = 'The Rouse Co.',
  keywords = ['rouse', 'intimacy drink', 'hydration', 'libido support', 'natural energy'],
  uploadDate = '2025-07-09',
  includeVideoSchema = true,
  thumbnailUrl1 = 'https://therouseco.com/assets/rouse_logo_3d-0556870b.webp',
  thumbnailUrl2 = 'https://therouseco.com/assets/rouse_logo_3d-0556870b.webp',
  contentUrl1 = 'https://therouseco.com/assets/Intro_movie_HD.webm',
  contentUrl2 = 'https://therouseco.com/assets/Intro_movie_HD.webm',
  videotitle1 = 'Rouse Launch Video',
  videotitle2 = 'Behind the Scenes of the Rouse Campaign',
  videodescription1 = 'Discover the science and feeling behind Rouse.',
  videodescription2 = 'Go behind the scenes of the Rouse campaign shoot.',
}: SeoProps) => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "name": name,
        "url": "https://therouseco.com",
        "logo": logo,
      },
      {
        "@type": "WebPage",
        "name": title,
        "url": url,
        "description": description,
        "inLanguage": "en"
      },
      ...(includeVideoSchema
        ? [
            {
              "@type": "VideoObject",
              name: videotitle1,
              description: videodescription1,
              thumbnailUrl: thumbnailUrl1,
              uploadDate: uploadDate,
              contentUrl: contentUrl1,
              embedUrl: contentUrl1
            },
            {
              "@type": "VideoObject",
              name: videotitle2,
              description: videodescription2,
              thumbnailUrl: thumbnailUrl2,
              uploadDate: uploadDate,
              contentUrl: contentUrl2,
              embedUrl: contentUrl2
            }
          ]
        : [])
    ]
  };

  return (
    <Helmet>

      {/* Meta Pixel base script */}
      <script>
        {`
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '1626977964679482');
          fbq('track', 'PageView');
        `}
      </script>

      <meta name="viewport" content="width=device-width, initial-scale=1.0" />

      {/* noscript fallback */}
      <noscript>
        {`<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1626977964679482&ev=PageView&noscript=1"/>`}
      </noscript>

      {/* ✅ FONT PRELOAD */}
      <link
        rel="preload"
        as="font"
        href="https://fonts.cdnfonts.com/s/133405/TwoWeekendsSans.woff2"
        type="font/woff2"
        crossOrigin="anonymous"
      />

      {/* ✅ FONT CSS */}
      <link
        rel="stylesheet"
        href="https://fonts.cdnfonts.com/css/two-weekends-sans"
      />
      {/* Title & Description */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords.join(', ')} />
      <meta name="robots" content="index, follow" />
      <meta name="author" content={name} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      {includeVideoSchema && (
        <meta property="og:video" content={contentUrl1} />
      )}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* JSON-LD structured data */}
      <script type="application/ld+json">
        {JSON.stringify(jsonLd)}
      </script>
    </Helmet>
  );
};

export default Seo;
